import {
  type Auth,
  AuthContext,
} from "@redotech/redo-merchant-app-common/auth";
import {
  ONBOARDING_RESUME_SOURCE_PARAM,
  parseOnboardingResumeSource,
} from "@redotech/redo-onboarding-api/resume-source";
import { memo, useContext } from "react";
import { autoOnboardingUrl } from ".";

export function getOnboardingRedirectUrl(
  auth: Pick<Auth, "teamId" | "token">,
  search: string,
): URL {
  const source = parseOnboardingResumeSource(
    new URLSearchParams(search).get(ONBOARDING_RESUME_SOURCE_PARAM),
  );
  return autoOnboardingUrl(auth.token, auth.teamId, source);
}

/**
 * Route component that redirects the user to the onboarding app with their
 * current auth token.  Used by the onboarding login modal so the flow is:
 *
 *   setup-vite (expired) → merchant login → /onboarding-redirect → setup-vite?token=…
 */
export const OnboardingRedirect = memo(function OnboardingRedirect() {
  const auth = useContext(AuthContext);

  if (auth) {
    location.href = getOnboardingRedirectUrl(auth, location.search).toString();
  }

  return null;
});
